import { reviewConstants } from "../constants/reviewConstants";

const initialState = {
  sendingData: false,
  sendedData: false,
  reviewResponse: {},
  error: "",
  updatedReview: false,
  updatingReview: false,
  reviewList: {},
  receivedReviewList: false,
  receivingReviewList: false,
  fetchedReview: false,
  fetchingReview: false,
  reviewDetails: {},
  receivedReviewListForAdmin: false,
  receivingReviewListForAdmin: false,
  reviewListForAdmin: {},
  sendingStatus: false,
  sendedStatus: false,
  statusResponse: {},
  deletingReview: false,
  deletedReview: false,
  deleteReviewResponse: {},
  updatedReviewByAdmin: false,
  updatingReviewByAdmin: false,
  updatedReviewResponseByAdmin: {},
  receivedReviewDetails: false,
  receivingReviewDetails: false,
  reviewDetailsForAdmin: {}
};

export default function reviewReducer(state = initialState, action) {
  switch (action.type) {
    case reviewConstants.ADD_REVIEW_REQUEST:
      return {
        ...state,
        sendingData: true,
        sendedData: false
      };
    case reviewConstants.ADD_REVIEW_SUCCESS:
      return {
        ...state,
        sendingData: false,
        sendedData: true,
        reviewResponse: action.data,
        error: ""
      };
    case reviewConstants.ADD_REVIEW_FAILURE:
      return {
        ...state,
        sendingData: false,
        sendedData: false,
        error: action.error
      };
    case reviewConstants.GET_REVIEW_REQUEST:
      return {
        ...state,
        receivedReviewList: false,
        receivingReviewList: true
      };
    case reviewConstants.GET_REVIEW_SUCCESS:
      return {
        ...state,
        receivedReviewList: true,
        receivingReviewList: false,
        reviewList: action.data.data
      };
    case reviewConstants.GET_REVIEW_FAILURE:
      return {
        ...state,
        receivingReviewList: false,
        receivedReviewList: false,
        error: action.error
      };
    case reviewConstants.UPDATE_REVIEW_REQUEST:
      return {
        ...state,
        sendedData: false,
        sendingData: true
      };
    case reviewConstants.UPDATE_REVIEW_SUCCESS:
      return {
        ...state,
        sendedData: true,
        sendingData: false,
        updatedReviewResponse: action.data
      };
    case reviewConstants.UPDATE_REVIEW_FAILURE:
      return {
        ...state,
        sendingData: false,
        sendingData: false,
        error: action.error
      };
    case reviewConstants.GET_REVIEW_DETAILS_REQUEST:
      return {
        ...state,
        fetchedReview: false,
        fetchingReview: true
      };
    case reviewConstants.GET_REVIEW_DETAILS_SUCCESS:
      return {
        ...state,
        fetchedReview: true,
        fetchingReview: false,
        reviewDetails: action.data.data
      };
    case reviewConstants.GET_REVIEW_DETAILS_FAILURE:
      return {
        ...state,
        fetchedReview: false,
        fetchingReview: false,
        error: action.error
      };
    case reviewConstants.GET_REVIEW_REQUEST_FOR_ADMIN:
      return {
        ...state,
        receivedReviewListForAdmin: false,
        receivingReviewListForAdmin: true
      };
    case reviewConstants.GET_REVIEW_SUCCESS_FOR_ADMIN:
      return {
        ...state,
        receivedReviewListForAdmin: true,
        receivingReviewListForAdmin: false,
        reviewListForAdmin: action.data.data
      };
    case reviewConstants.GET_REVIEW_FAILURE_FOR_ADMIN:
      return {
        ...state,
        receivingReviewListForAdmin: false,
        receivedReviewListForAdmin: false,
        error: action.error
      };
    case reviewConstants.CHANGE_REVIEW_STATUS_REQUEST:
      return {
        ...state,
        sendingStatus: true,
        sendedStatus: false
      };
    case reviewConstants.CHANGE_REVIEW_STATUS_SUCCESS:
      return {
        ...state,
        sendedStatus: true,
        sendingStatus: false,
        statusResponse: action.data
      };
    case reviewConstants.CHANGE_REVIEW_STATUS_FAILURE:
      return {
        ...state,
        sendedStatus: false,
        sendingStatus: false,
        error: action.error
      };
    case reviewConstants.DELETE_REVIEW_REQUEST:
      return {
        ...state,
        deletingReview: true,
        deletedReview: false
      };
    case reviewConstants.DELETE_REVIEW_SUCCESS:
      return {
        ...state,
        deletedReview: true,
        deletingReview: false,
        deleteReviewResponse: action.data
      };
    case reviewConstants.DELETE_REVIEW_FAILURE:
      return {
        ...state,
        deletedReview: false,
        deletingReview: false,
        error: action.error
      };
    case reviewConstants.UPDATE_REVIEW_BY_ADMIN_REQUEST:
      return {
        ...state,
        updatingReviewByAdmin: true,
        updatedReviewByAdmin: false
      };
    case reviewConstants.UPDATE_REVIEW_BY_ADMIN_SUCCESS:
      return {
        ...state,
        updatedReviewByAdmin: true,
        updatingReviewByAdmin: false,
        updatedReviewResponseByAdmin: action.data
      };
    case reviewConstants.UPDATE_REVIEW_BY_ADMIN_FAILURE:
      return {
        ...state,
        updatedReviewByAdmin: false,
        updatingReviewByAdmin: false,
        error: action.error
      };
    case reviewConstants.GET_REVIEW_DETAILS_FOR_ADMIN_REQUEST:
      return {
        ...state,
        receivingReviewDetails: true,
        receivedReviewDetails: false
      };
    case reviewConstants.GET_REVIEW_DETAILS_FOR_ADMIN_SUCCESS:
      return {
        ...state,
        receivedReviewDetails: true,
        receivingReviewDetails: false,
        reviewDetailsForAdmin: action.data.data
      };
    case reviewConstants.GET_REVIEW_DETAILS_FOR_ADMIN_FAILURE:
      return {
        ...state,
        receivedReviewDetails: false,
        receivingReviewDetails: false,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/reviewReducer.js